import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import createReducer from './reducer';
import saga from './saga';

export const history = createBrowserHistory();
export const sagaMiddleware = createSagaMiddleware();

export default () => {
    const store = configureStore({
        reducer: createReducer(history),
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware()
                .prepend(sagaMiddleware)
                .prepend(routerMiddleware(history)),
    });

    sagaMiddleware.run(saga);

    return store;
};
